// extracted by mini-css-extract-plugin
export default {"fab":"WhatsAppButton_fab__DBVTU","icon":"WhatsAppButton_icon__Kr+wb","label":"WhatsAppButton_label__j5IZA"};